import React from "react";

function LinkBlock({ links }) {
    const getLinkUrl = (link) => {
        if (link.link_page && link.link_page.url) return link.link_page.url;
        if (link.document && link.document.url) return link.document.url;
        if (link.link_url) return link.link_url;
        return "#";
    };

    return (
        <div className="link-block row justify-content-center">
            {links && links.length ? (
                links.map((link, index) => {
                    const url = getLinkUrl(link);
                    return (
                        <a href={url} className="col-lg-8 link-col" key={index} target="_blank" rel="noopener noreferrer">
                            <div key={index} className="link-row d-flex justify-content-between align-items-center">
                                <h3 className="">{link.link_text}</h3>
                                <div className="green-arrow-btn d-none d-md-flex">
                                    <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.66675 11H5.83341H1.66675ZM28.3334 11L18.3334 1L28.3334 11ZM28.3334 11L18.3334 21L28.3334 11ZM28.3334 11H10.8334H28.3334Z" fill="#ffffff" />
                                        <path d="M1.66675 11H5.83341M28.3334 11L18.3334 1M28.3334 11L18.3334 21M28.3334 11H10.8334" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className="green-arrow-btn small d-flex d-md-none">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.3335 16H8.66683H5.3335ZM26.6668 16L18.6668 8L26.6668 16ZM26.6668 16L18.6668 24L26.6668 16ZM26.6668 16H12.6668H26.6668Z" fill="#ffffff" />
                                        <path d="M5.3335 16H8.66683M26.6668 16L18.6668 8M26.6668 16L18.6668 24M26.6668 16H12.6668" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>

                                </div>
                            </div>
                        </a>
                    );
                })
            ) : (
                <p>No links found.</p>
            )}
        </div>
    );
}

export default LinkBlock;
